<template>
  <b-modal 
    ref="modal" 
    id="modal-pedido-etiqueta-avulsa" 
    hide-header
    hide-footer
    body-class="p-0 overflow-hidden"
    content-class="border-0 shadow-lg"
    centered
    size="lg"
    @shown="onModalShown()" 
    @hidden="onModalHidden()"
  >
    <b-overlay :show="processando" rounded="sm" opacity="0.8">
      <template #overlay>
        <div class="text-center">
          <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
          <p class="mt-2 mb-0 font-weight-bold">{{ mensagemProcessando }}</p>
        </div>
      </template>

      <!-- Cabeçalho Premium -->
      <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" 
           style="background: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%) !important;">
        <div class="header-icon-wrapper mr-3 bg-white-10">
          <i class="fa fa-tag text-white"></i>
        </div>
        <div>
          <h5 class="mb-0 font-weight-bold text-white">{{ isEdicao ? 'Editar Pedido' : 'Novo Pedido' }} de Etiqueta Avulsa</h5>
          <small class="text-white opacity-75">{{ isEdicao ? `#${registro.ID}` : 'Preencha os dados do pedido' }}</small>
        </div>
        <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="fechar()">
          <i class="fa fa-times fa-lg"></i>
        </b-button>
      </div>

      <!-- Corpo do Modal -->
      <div class="p-4">
        <!-- Campos do Formulário -->
        <b-row>
          <b-col md="12" v-if="isEdicao">
            <b-form-group label="ID" label-class="modal-label-premium">
              <b-form-input 
                v-model="registro.ID" 
                disabled
                class="rounded-pill shadow-xs"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Data do Cadastro" label-class="modal-label-premium">
              <b-form-input 
                v-model="dataCadastroFormatada" 
                disabled
                class="rounded-pill shadow-xs"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Situação" label-class="modal-label-premium">
              <div class="d-flex align-items-center" style="height: 38px;">
                <b-badge 
                  pill 
                  class="px-4 py-2 shadow-xs" 
                  :variant="situacaoVariant"
                  style="font-size: 0.9rem;"
                >
                  {{ situacaoTexto }}
                </b-badge>
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group label="Previsão de Produção *" label-class="modal-label-premium">
              <cec-input-data
                ref="dataPrevisao"
                v-model="registro.DATA"
                input-class="rounded-pill shadow-xs"
                placeholderText="Selecione a data"
                :disabled="!podeEditar"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Tipo de Produção *" label-class="modal-label-premium">
              <b-form-select 
                v-model="registro.OP_TIPO" 
                class="rounded-pill shadow-xs"
                required
                :disabled="!podeEditar"
              >
                <b-form-select-option :value="null">Selecione...</b-form-select-option>
                <b-form-select-option value="0">Troca de Tampa</b-form-select-option>
                <b-form-select-option value="1">Outros</b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="8">
            <b-form-group label="Número do Lote (YYMMDD)" label-class="modal-label-premium">
              <b-form-input 
                v-model="registro.LOTE" 
                class="rounded-pill shadow-xs"
                maxlength="10"
                @blur="buscarProximoDigito"
                :disabled="!podeEditar"
              />
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="Dígito" label-class="modal-label-premium">
              <b-form-input 
                v-model="registro.LOTE_DIGITO" 
                type="number"
                class="rounded-pill shadow-xs"
                min="1"
                :disabled="!podeEditar"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-group label="Solicitante" label-class="modal-label-premium">
              <funcionario-dropdown
                v-model="registro.RESPONSAVEL_ID"
                placeholder="Selecione o solicitante..."
                input-class="rounded-pill shadow-xs"
                :disabled="!podeEditar"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-group label="Observações" label-class="modal-label-premium">
              <b-form-textarea
                v-model="registro.OBSERVACAO"
                rows="3"
                max-rows="6"
                class="rounded shadow-xs"
                placeholder="Observações adicionais..."
                :disabled="!podeEditar"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <!-- Rodapé de Ações -->
      <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
        <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="fechar()">
          <i class="fa fa-times mr-1"></i> {{ podeEditar ? 'CANCELAR' : 'FECHAR' }}
        </b-button>
        <b-button v-if="podeEditar" variant="success" pill class="px-5 font-weight-bold shadow-sm" @click="salvar()">
          <i class="fa fa-check-circle mr-1"></i> {{ isEdicao ? 'ATUALIZAR' : 'SALVAR' }}
        </b-button>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import Tools from '@/tools/tools.js'
import FuncionarioDropdown from '@/views/componentes/dropdown/FuncionarioDropdown.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'

export default {
  components: {
    FuncionarioDropdown,
    CecInputData
  },

  data() {
    return {
      processando: false,
      mensagemProcessando: 'Processando...',
      isEdicao: false,
      registro: {
        ID: null,
        DATA: null,
        USUARIO: null,
        SITUACAO: '1',
        OBSERVACAO: null,
        DATA_CADASTRO: null,
        LOTE: null,
        LOTE_DIGITO: 1,
        OP_TIPO: '0',
        RESPONSAVEL_ID: null
      },
      loteGerado: false
    }
  },

  computed: {
    dataCadastroFormatada() {
      if (this.registro.DATA_CADASTRO) {
        return Tools.formatarDataHoraBR(this.registro.DATA_CADASTRO)
      }
      return Tools.formatarDataHoraBR(new Date())
    },
    situacaoTexto() {
      const map = {
        '0': 'CANCELADO',
        '1': 'EM CADASTRO',
        '2': 'LIBERADO P/ COLETA',
        '3': 'EM COLETA',
        '4': 'COLETADO'
      }
      return map[this.registro.SITUACAO] || 'DESCONHECIDO'
    },
    situacaoVariant() {
      const map = {
        '0': 'danger',
        '1': 'warning',
        '2': 'info',
        '3': 'primary',
        '4': 'success'
      }
      return map[this.registro.SITUACAO] || 'secondary'
    },
    podeEditar() {
      // Pode editar apenas se SITUACAO = '1' ou '2'
      return this.registro.SITUACAO === '1' || this.registro.SITUACAO === '2'
    }
  },

  methods: {
    abrir(item) {
      this.resetar()
      
      if (item && item.ID) {
        // Edição
        this.isEdicao = true
        this.carregarRegistro(item.ID)
      } else {
        // Novo
        this.isEdicao = false
        this.gerarLotePadrao()
      }
      
      this.$nextTick(() => {
        this.$bvModal.show('modal-pedido-etiqueta-avulsa')
      })
    },

    fechar() {
      this.$bvModal.hide('modal-pedido-etiqueta-avulsa')
    },

    resetar() {
      this.registro = {
        ID: null,
        DATA: null,
        USUARIO: null,
        SITUACAO: '1',
        OBSERVACAO: null,
        DATA_CADASTRO: null,
        LOTE: null,
        LOTE_DIGITO: 1,
        OP_TIPO: '0',
        RESPONSAVEL_ID: null
      }
      this.loteGerado = false
    },

    gerarLotePadrao() {
      // Gerar lote no formato YYMMDD
      const hoje = new Date()
      const yy = String(hoje.getFullYear()).slice(-2)
      const mm = String(hoje.getMonth() + 1).padStart(2, '0')
      const dd = String(hoje.getDate()).padStart(2, '0')
      
      this.registro.LOTE = `${yy}${mm}${dd}`
      
      // Inicializar data de previsão com data atual
      this.registro.DATA = Tools.getDataAtual()
      
      this.loteGerado = true
      
      // Buscar próximo dígito
      this.buscarProximoDigito()
    },

    async buscarProximoDigito() {
      if (!this.registro.LOTE || this.registro.LOTE.length < 6) return
      
      try {
        const { data } = await this.$http.get(`/api/protected/pedido-etiqueta-avulsa/proximoDigitoLote/${this.registro.LOTE}`)
        if (data && data.PROXIMO_DIGITO) {
          this.registro.LOTE_DIGITO = data.PROXIMO_DIGITO
        }
      } catch (err) {
        console.error('Erro ao buscar próximo dígito:', err)
      }
    },

    async carregarRegistro(id) {
      this.mensagemProcessando = 'Carregando dados...'
      this.processando = true
      
      try {
        const { data } = await this.$http.get(`/api/protected/pedido-etiqueta-avulsa/getById/${id}`)
        if (data && data.length > 0) {
          this.registro = { ...data[0] }
          
          // Formatar data para input date
          if (this.registro.DATA) {
            this.registro.DATA = Tools.formatarDataParaInput(this.registro.DATA)
          }
        }
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao carregar dados do pedido')
      } finally {
        this.processando = false
      }
    },

    validar() {
      if (!this.registro.DATA) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Informe a data de previsão de produção')
        this.$refs.dataPrevisao.focus()
        return false
      }

      if (!this.registro.OP_TIPO) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Selecione o tipo de produção')
        return false
      }

      if (!this.registro.LOTE || this.registro.LOTE.length < 6) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Informe o lote no formato YYMMDD')
        return false
      }

      if (!this.registro.LOTE_DIGITO || this.registro.LOTE_DIGITO < 1) {
        Tools.exibirMensagem(this.$store, 'Atenção', 'warning', 'Informe o dígito do lote')
        return false
      }

      return true
    },

    async salvar() {
      if (!this.validar()) return

      this.mensagemProcessando = this.isEdicao ? 'Atualizando...' : 'Salvando...'
      this.processando = true

      try {
        const endpoint = this.isEdicao 
          ? '/api/protected/pedido-etiqueta-avulsa/edit'
          : '/api/protected/pedido-etiqueta-avulsa/post'

        const payload = {
          registro: this.registro,
          login: window.localStorage.getItem('login')
        }

        const { data } = await this.$http.post(endpoint, payload)

        if (data && data.result === 'sucesso') {
          Tools.exibirMensagem(
            this.$store, 
            'Sucesso', 
            'success', 
            this.isEdicao ? 'Pedido atualizado com sucesso!' : 'Pedido cadastrado com sucesso!'
          )
          this.$emit('salvou', data.registro)
          this.fechar()
        }
      } catch (err) {
        let msg = err.response?.data || err.message
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', msg)
      } finally {
        this.processando = false
      }
    },

    onModalShown() {
      this.$nextTick(() => {
        if (!this.isEdicao) {
          this.$refs.dataPrevisao?.focus()
        }
      })
    },

    onModalHidden() {
      this.resetar()
    }
  }
}
</script>

<style scoped>
.modal-header-premium {
  border-bottom: none;
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-bottom: 0.4rem;
  display: block;
}

.shadow-xs {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}

.btn-soft-danger {
  background-color: rgba(248, 108, 107, 0.1);
  color: #f86c6b;
  border: none;
}
.btn-soft-danger:hover {
  background-color: #f86c6b;
  color: white;
}

.opacity-75 {
  opacity: 0.75;
}

/* Vue-select custom styles */
.style-chooser >>> .vs__dropdown-toggle {
  border-radius: 50rem;
  border: 1px solid #ced4da;
  padding: 0.375rem 1rem;
}

.style-chooser >>> .vs__search {
  padding: 0;
}

.style-chooser >>> .vs__selected {
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/estoque/pedido-etiqueta-avulsa/PedidoEtiquetaAvulsaModal.vue